// extracted by mini-css-extract-plugin
module.exports = {"blog__post":"BlogPost_blog__post__zv5_I","featured-article":"BlogPost_featured-article__srYBQ"};